import axios from 'axios';

const GITHUB_API = process.env.REACT_APP_GITHUB_API;
const GITHUB_TOKEN = process.env.REACT_APP_GITHUB_TOKEN;

// Create axios instance with default headers
const api = axios.create({
  baseURL: GITHUB_API,
  headers: GITHUB_TOKEN ? {
    'Authorization': `token ${GITHUB_TOKEN}`,
    'Accept': 'application/vnd.github.v3+json'
  } : {
    'Accept': 'application/vnd.github.v3+json'
  }
});

// Request throttling
const API_DELAY = 100; // 100ms delay between requests
let requestQueue = [];
let isProcessingQueue = false;

const queueRequest = (url) => {
  return new Promise((resolve, reject) => {
    requestQueue.push({ url, resolve, reject });
    processQueue();
  });
};

const processQueue = async () => {
  if (isProcessingQueue || requestQueue.length === 0) {
    return;
  }

  isProcessingQueue = true;

  while (requestQueue.length > 0) {
    const { url, resolve, reject } = requestQueue.shift();

    try {
      const response = await api.get(url);
      resolve(response.data);
    } catch (error) {
      if (error.response?.status === 403 && error.response?.headers['x-ratelimit-remaining'] === '0') {
        reject(new Error('RATE_LIMIT_EXCEEDED'));
      } else {
        reject(error);
      }
    }

    // Add delay between requests
    if (requestQueue.length > 0) {
      await new Promise(resolve => setTimeout(resolve, API_DELAY));
    }
  }

  isProcessingQueue = false;
};

export const githubApi = {
  // Get repository contents
  getContents: async (path = '') => {
    const url = path ? `/contents/${encodeURIComponent(path)}` : '/contents';
    return queueRequest(url);
  },

  // Get repository info
  getRepoInfo: async () => {
    return queueRequest('');
  },

  // Get commit history
  getCommits: async (page = 1, perPage = 30) => {
    const url = `/commits?page=${page}&per_page=${perPage}`;
    return queueRequest(url);
  },

  // Get latest commit (for last updated)
  getLatestCommit: async () => {
    const url = '/commits?page=1&per_page=1';
    return queueRequest(url);
  }
};

export default githubApi;